import axios from 'axios';
import Cookies from 'js-cookie';

const baseURL = import.meta.env.VITE_API_URL;

export default function axiosInstances() {
	// Get the current token each time the function is called
	const token = Cookies.get('bdKey');

	const axiosInstance = axios.create({
		baseURL,
		headers: {
			Authorization: token ? `Bearer ${token}` : undefined,
			'Content-Type': 'application/json',
		},
	});

	const axiosInstanceF = axios.create({
		baseURL,
		headers: {
			Authorization: token ? `Bearer ${token}` : undefined,
			'Content-Type': 'multipart/form-data',
		},
	});

	// Add response interceptor to handle 401 errors
	axiosInstance.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response?.status === 401) {
				console.error('Unauthorized request:', error.config.url);
				// You might want to trigger a refresh token flow here
			}
			return Promise.reject(error);
		}
	);

	axiosInstanceF.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response?.status === 401) {
				console.error('Unauthorized request:', error.config.url);
				// You might want to trigger a refresh token flow here
			}
			return Promise.reject(error);
		}
	);

	return { axiosInstance, axiosInstanceF };
}
